import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';

import { MedicStore } from '../state/medic.store';
import { UiStore } from '../state/ui.store';

/**
 * Navigarea in fisa medicului. Medicul si sectiunea stau in URL (/medic/:id/:sectiune),
 * asa ca butonul Inapoi, linkurile si revenirea dupa login pastreaza medicul deschis.
 */
@Service()
export class MedicNavigare {
    private readonly router = inject(Router);
    private readonly uiStore = inject(UiStore);
    private readonly medicStore = inject(MedicStore);

    /** Deschide fisa altui medic (din cautare, IMI etc.), fara datele medicului anterior. */
    deschide(medicId: string, sectiune = 'dashboard') {
        this.uiStore.setAppSubsectionState(null);
        this.medicStore.setMedicAvizDraft(null);
        this.medicStore.setMedicCertDraft(null);
        this.medicStore.unsetMedicData();
        return this.router.navigate(['/medic', medicId, sectiune]);
    }

    /** Trece la alta sectiune a medicului deschis. */
    sectiune(sectiune: string) {
        const medicId = this.uiStore.currentMedicId();
        if (!medicId) {
            return this.router.navigate(['/dashboard']);
        }
        return this.router.navigate(['/medic', medicId, sectiune]);
    }

    /** Formularul de inregistrare a unui medic nou. */
    nou() {
        this.uiStore.removeMedicId();
        this.medicStore.unsetMedicData();
        this.uiStore.setMedicNume('Nou');
        return this.router.navigate(['/medic/nou']);
    }
}
